import { createApiClient } from '@mjl/shared';

/** Client Spotlight — base URL dari VITE_SPOTLIGHT_URL (inline saat build CDN). */
export const spotlightApi = createApiClient(import.meta.env.VITE_SPOTLIGHT_URL ?? '');

/** Client SSO (my-app) — base URL dari VITE_SSO_URL. */
export const ssoApi = createApiClient(import.meta.env.VITE_SSO_URL ?? '');
